module.exports = __webpack_public_path__ + "media/flags/sc-07bc7148.svg";